import { useFormat } from '@ideavivat/vivat-2';

export const target_date = {
  name: 'วันที่เป้าหมาย',
  width: '8rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
};

export const created_at = {
  name: 'วันทำรายการ',
  width: '10rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
};
